 
import { makeRequest } from '../../../lib/api';
import {
  CreatePriceListRequest,
  GetPriceListRequest,
  EditPriceListRequest,
  GetPriceListRegionRequest,
  CreatePriceListRegionRequest,
  GetPriceListItemRequest,
  EditPriceListItemRequest,
  CreatePriceListItemRequest,
  DeletePriceListItemRequest,
  GetPriceListStationaryRequest,
  CalculatePriceRequest,
  CalculatePriceStorageRequest,
} from '../api/priceListApi';

const PRICELIST_PATH = '/v1/price_lists';
const PRICE_CALC_PATH = '/v1/open/calculate';
const PRICE_CALC_STAT_PATH = '/v1/prices';

// const SUBJECT_OF_THE_RUSSIAN_FEDERATION = '/v1/regions';

const priceListController = {
  getPriceLists: (request: GetPriceListRequest): Promise<any> => {
    let paramString = request.showDeleted ? '?showDeleted=true' : '?showDeleted=false';
    paramString = request.partnerId ? `${ paramString }&partnerId=${ request.partnerId }` : paramString;
    // paramString = request.serviceId ? `${ paramString }&serviceId=${ request.serviceId }` : paramString;
    return makeRequest('get', `${ PRICELIST_PATH }${ paramString }`);
  },

  getPriceListsForInvoices: (request: GetPriceListRequest): Promise<any> => {
    let paramString = request.showDeleted ? '?showDeleted=true' : '?showDeleted=false';
    paramString = request.partnerId ? `${ paramString }&partnerId=${ request.partnerId }` : paramString;
    paramString = request.serviceId ? `${ paramString }&serviceId=${ request.serviceId }` : paramString;
    return makeRequest('get', `${ PRICELIST_PATH }/for_invoices${ paramString }`);
  },

  // метод ниже возвращает прайс, с которым работает офис
  getPriceListsStationaryForInvoices: (request: GetPriceListStationaryRequest): Promise<any> => {
    let paramString = request.showDeleted ? '?showDeleted=true' : '?showDeleted=false';
    // eslint-disable-next-line max-len
    paramString = request.partnerOfficeId ? `${ paramString }&partnerOfficeId=${ request.partnerOfficeId }` : paramString;
    paramString = request.serviceId ? `${ paramString }&serviceId=${ request.serviceId }` : paramString;
    return makeRequest('get', `${ PRICELIST_PATH }/stationary/for_invoices${ paramString }`);
  },

  getSpecificPriceList: (id: string): Promise<any> => {
    return makeRequest('get', `${ PRICELIST_PATH }/${ id }`);
  },

  // история изменений прайс-листа
  getPriceListHistory: (id: string): Promise<any> => {
    return makeRequest('get', `${ PRICELIST_PATH }/${ id }/history`);
  },

  getSovcombankSnapshot: (): Promise<any> => {
    return makeRequest('get', '/v1/price_lists/tire_fitting/offices_pricebook_snapshot');
  },

  createPriceList: (request: CreatePriceListRequest): Promise<any> => {
    return makeRequest('post', PRICELIST_PATH, request);
  },

  editPriceList: (id: string, request: EditPriceListRequest): Promise<any> => {
    return makeRequest('put', `${ PRICELIST_PATH }/${ id }`, request);
  },

  deletePriceList: (id: string): Promise<any> => {
    return makeRequest('delete', `${ PRICELIST_PATH }/${ id }`);
  },

  // восстановление удалённого прайс-листа
  restorePriceList: (id: string): Promise<any> => {
    return makeRequest('post', `${ PRICELIST_PATH }/${ id }`);
  },

  // блок регионов по прайс-листу
  getPriceListRegions: (request: GetPriceListRegionRequest): Promise<any> => {
    const priceListIdString = `?priceListId=${ request.priceListId }`;
    return makeRequest('get', `${ PRICELIST_PATH }/regions${ priceListIdString }`);
  },

  createPriceListRegion: (request: CreatePriceListRegionRequest): Promise<any> => {
    return makeRequest('post', `${ PRICELIST_PATH }/regions`, request);
  },

  deletePriceListRegion: (id: string): Promise<any> => {
    return makeRequest('delete', `${ PRICELIST_PATH }/regions/${ id }`);
  },
  // блок регионов по прайс-листу

  // блок позиций по прайс-листу
  getPriceListItems: (request: GetPriceListItemRequest): Promise<any> => {
    const priceListIdString = `?priceListId=${ request.priceListId }`;
    const positionDeletedString = request.showDeleted ? '&showDeleted=true' : '&showDeleted=false';
    return makeRequest('get', `${ PRICELIST_PATH }/items${ priceListIdString }${ positionDeletedString }`);
  },

  addAllPriceListItems: (id: string): Promise<any> => {
    return makeRequest('post', `${ PRICELIST_PATH }/items?priceListId=${ id }`);
  },

  addAllItemsToExistPositions: (id: string): Promise<any> => {
    return makeRequest('put', `${ PRICELIST_PATH }/items?priceListId=${ id }`);
  },

  editPriceListItem: (id: string, request: EditPriceListItemRequest): Promise<any> => {
    return makeRequest('put', `${ PRICELIST_PATH }/items/${ id }`, request);
  },

  // добавление отдельного Item в прайс
  createPriceListItem: (request: CreatePriceListItemRequest): Promise<any> => {
    return makeRequest('post', `${ PRICELIST_PATH }/positions/${ request.positionId }/items?priceListId=${ request.priceListId }`, request);
  },

  // В указанном прайс-листе дополнить набор записей по всем уже имеющимся в нем номенкл. позициям
  // до полного набора (т.е. со всеми сочетаниями значений классификаторов на данный момент)
  putPriceListItem: (request: CreatePriceListItemRequest): Promise<any> => {
    return makeRequest('put', `${ PRICELIST_PATH }/positions/${ request.positionId }/items`, request);
  },

  // удаление отдельного Item в  прайсе
  deletePriceListItem: (id: string): Promise<any> => {
    return makeRequest('delete', `${ PRICELIST_PATH }/items/${ id }`);
  },

  // удаление всей позиции по positionId в  прайсе
  deletePriceListItemPosition: (request: DeletePriceListItemRequest): Promise<any> => {
    return makeRequest('delete', `${ PRICELIST_PATH }/items?positionId=${ request.positionId }&priceListId=${ request.priceListId }`);
  },

  clearCachePriceInRedis: (): Promise<any> => {
    return makeRequest('delete', `${ PRICELIST_PATH }/response_cache/calculations/prices`);
  },
  // блок позиций по прайс-листу

  // получение цены
  getPrice: (request: CalculatePriceRequest): Promise<any> => {
    return makeRequest('post', `${ PRICE_CALC_PATH }/station_tire_fitting`, request);
  },

  getStoragePrice: (request: CalculatePriceStorageRequest): Promise<any> => {
    return makeRequest('post', `${ PRICE_CALC_PATH }/station_tire_storage`, request);
  },

  getCalculateComplexTableList: (priceListId : string): Promise<any> => {
    return makeRequest('get', `${ PRICE_CALC_STAT_PATH }/tire_fitting/price_lists/${ priceListId }/complexes`);
  },

  // цены комплексов (за 1 колесо) для одной комбинации тип ТС × диаметр — Б8, мастер заявки ШМ
  getComplexPrices: (
    priceListId: string,
    vehicleTypeRefValueId: number,
    diameterRefValueId: number
  ): Promise<any> => {
    return makeRequest(
      'get',
      `${ PRICE_CALC_STAT_PATH }/tire_fitting/price_lists/${ priceListId }/complex_prices`
      + `?vehicleTypeRefValueId=${ vehicleTypeRefValueId }&diameterRefValueId=${ diameterRefValueId }`
    );
  },
};

export { priceListController };
